export default __webpack_public_path__ + "static/media/diagram_zoom.9260d2a2.jpg";